import { createContext, CSSProperties, useEffect, useMemo } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { covertErrors, ResponseError } from "utils/ErrorConverter";

type FormProps = {
  onSubmit?: (data: any) => void;
  error?: { message: string; errors: ResponseError };
  isLoading?: boolean;
  children: React.ReactNode;
  formStyle?: CSSProperties;
  defaultValues?: any;
};

export type FormStatus = {
  isLoading: boolean;
};

export const FormStatusContext = createContext<FormStatus>({
  isLoading: false,
  
});

export const Form: React.FC<FormProps> = function (props) {
  const methods = useForm({ defaultValues: props.defaultValues });

  const errors = useMemo(() => {
    if (!props.error) {
      return [];
    }

    return covertErrors({
      errors: props?.error?.errors,
    });
  }, [props.error]);

  useEffect(() => {
    for (const error of errors) {
      methods.setError(error.key, { message: error.message });
    }
  }, [errors, methods]);

  useEffect(() => {
    methods.reset(props.defaultValues);
  }, [methods, props.defaultValues]);

  const contextValue = useMemo(() => ({isLoading: props.isLoading || false}), [props.isLoading]);

  return (
    <FormStatusContext.Provider value={contextValue}>
      <FormProvider {...methods}>
        <form
          onSubmit={
            props.onSubmit ? methods.handleSubmit(props.onSubmit) : undefined
          }
          style={props.formStyle}
        >
          {props.children}
        </form>
      </FormProvider>
    </FormStatusContext.Provider>
  );
};
